// Funzione che crea il pdf con il dettaglio di tutte le submission lists
// ricevute nel corso del tempo da una certa azienda di gradazione
import {jsPDF} from "jspdf";
import {
  CURRENCY_EURO,
  isPresent,
  parseAmount,
  parseFilterName,
  parseSubmissionListProcessingTime, 
  parseUserFullName,
  parseSubmissionListState,
  titleize
} from "../utils";
import 'jspdf-autotable'
import I18n from 'i18n.js.erb'
import {koruri} from "./Koruri-Regular-normal";
import {koruriBold} from "./Koruri-Bold-normal";


const tab = "        "
const space = " "

const writeBoldText = (jsPDFDocument, text, xPosition, yPosition) => {
  jsPDFDocument.setFont('Helvetica', '', 'Bold')
  jsPDFDocument.text(text, xPosition, yPosition)
  jsPDFDocument.setFont('Helvetica', '', '')
}

const addFooters = (doc) => {
  const pageCount = doc.internal.getNumberOfPages()

  doc.setFont('helvetica', 'italic')
  doc.setFontSize(8)

  for (var i = 1; i <= pageCount; i++) {
    doc.setPage(i)
    doc.text('Page ' + String(i) + ' of ' + String(pageCount), doc.internal.pageSize.width / 2, 205, {
      align: 'center'
    })
  }
}

const getTableRow = (submissionList, environment, isSuperMiddleman, influencersReport) => {

  var number = submissionList.number

  var username = '';
  if (environment === 'backoffice') {
    const userOwnerFullName = parseUserFullName(submissionList.user.first_name, submissionList.user.last_name)
    username =
      (userOwnerFullName && userOwnerFullName !== submissionList.user.email ? userOwnerFullName + '\n' + submissionList.user.email : (userOwnerFullName ? userOwnerFullName : submissionList.user.email)) +
      (submissionList.user_shipment_address?.phone_number ? '\n' + submissionList.user_shipment_address.phone_number : '')
  } else {
    const userOwnerFullName = submissionList.user_owner;
    username =
      (userOwnerFullName && userOwnerFullName !== submissionList.owner_email ? userOwnerFullName + '\n' + submissionList.owner_email : (userOwnerFullName ? userOwnerFullName : submissionList.owner_email))
  }

  var middleman = submissionList.middleman?.business_name
  var title = submissionList.title
  var state = parseSubmissionListState(environment === 'backoffice' ? submissionList.state : submissionList.front_office_state).toUpperCase()
  var items_count = submissionList.items_count
  var amount = parseAmount(submissionList.amount, 2) + CURRENCY_EURO +
    (submissionList.voucher ? '\n\n' + '(' + (submissionList.voucher.amount ? submissionList.voucher.amount.toString() + CURRENCY_EURO + space + I18n.t('js.PDFGenerator.submissionList.discount') : submissionList.voucher.percentage.toString() + '%' + space + I18n.t('js.PDFGenerator.submissionList.discount') ) + ')' : '') +
    (submissionList.payment_method ? '\n\n' + titleize(submissionList.payment_method.replaceAll('_', ' ')) : '')
  var gradingServiceAmount = parseAmount(submissionList.grading_service_amount, 2) + CURRENCY_EURO
  var influencerCommission = parseAmount(submissionList.influencer_commission, 2) + CURRENCY_EURO
  var discountCode = submissionList.voucher ? submissionList.voucher.code : '';
  var invoice = submissionList.invoice
  var confirmed_at = submissionList.confirmed_at
  var received_at = submissionList.received_at
  var created_at = submissionList.created_at
  var closed_at = submissionList.closed_at
  var created_by = I18n.t(`js.PDFGenerator.submissionLists.${submissionList.created_by}`) + (submissionList.shadow ? '\n\n(SHADOW)' : '')
  var homePickUp = submissionList.home_pick_up_requested ? (I18n.t('js.common.choice_yes') + (environment === 'backoffice' && (!submissionList.middleman || !submissionList.middleman.shipping_discount_products_threshold) ? (submissionList.home_pick_up_courier_sent ? '\n\nCourier already sent' : '\n\nCourier not sent yet') : '')): '';
  var tracking_info = submissionList.courier?.meta_name ?
    (submissionList.courier.meta_name + (submissionList.tracking_number && submissionList.tracking_number ? '\n\n' + submissionList.tracking_number : '')) : ''

  if (submissionList.received_at && submissionList.closed_at)
    var processing_time = parseSubmissionListProcessingTime(submissionList)

  return environment === 'backoffice' ?
    (
      !influencersReport ?
        [number, username, middleman, title, state, items_count, amount, invoice, created_by, created_at, confirmed_at, received_at, closed_at, processing_time, homePickUp, tracking_info]
      :
        [number, confirmed_at, gradingServiceAmount, influencerCommission, discountCode]
    )
  :
    (
      isSuperMiddleman ?
        [number, username, middleman, title, state, items_count, amount, created_at, confirmed_at, received_at, closed_at, tracking_info]
      :
        [number, username, title, state, items_count, amount, created_at, confirmed_at, received_at, closed_at, tracking_info]
    )
}


const filterCreatedBy = (value, companyPoint) => {
  if (value === 'middleman')
    return companyPoint;
  else
    return titleize(value);
}

const filterMiddlemanBusinessname = (middleman, companyPoint) => {
  if (middleman === 'no_middleman')
    return `No ${companyPoint}`;
  else if (middleman === 'all_middlemen')
    return `All ${companyPoint}`;
  else
    return middleman;
}

const filterUsername = (users, id) => {
  const user = users.filter(user => user[1] == id )[0];
  return user[3] ? user[3] : user[2]
}

const filterGraderCompany = (graderCompanies, id) => {
  const company = graderCompanies.filter(c => c.id == id )[0];
  return company.meta_name;
}

const parseBoolean = (value) => {
  return ['true', true].includes(value) ? 'YES' : 'NO'
}


export const submissionListsPDF = (submissionLists, filters, users, graderCompanies, environment, companyPoint, isSuperMiddleman, influencersReport) => {

  const doc = new jsPDF({orientation: "landscape"});
  doc.addFileToVFS("Koruri-Regular.ttf", koruri);
  doc.addFont("Koruri-Regular.ttf", "Koruri-Regular", "normal");
  doc.addFileToVFS("Koruri-Bold-normal.ttf", koruriBold);
  doc.addFont("Koruri-Bold-normal.ttf", "Koruri-Bold", "bold");
  doc.setFont('Helvetica')
  var img = new Image()
  img.src = '/images/square.png'
  doc.addImage(img, 'png', 10, 1, 15, 15)
  doc.setFontSize(24)
  writeBoldText(doc, I18n.t('js.PDFGenerator.submissionLists.main_title'), 28, 13)

  doc.line(10, 18, 200, 18, 'FD')
  doc.setFontSize(18)
  doc.text(submissionLists.submission_lists_count + space + I18n.t('js.PDFGenerator.submissionLists.submissionLists') + space + '(' + submissionLists.items_count + space + I18n.t('js.PDFGenerator.submissionLists.products') + ')', 10, 26);
  if (!influencersReport)
    doc.text(parseAmount(submissionLists.global_amount, 2) + CURRENCY_EURO, 198, 26, {align: 'right'});
  else
    doc.text(`${parseAmount(submissionLists.global_grading_service_amount, 2) + CURRENCY_EURO}, Infl. Comm.: ${parseAmount(submissionLists.global_influencer_commissions, 2) + CURRENCY_EURO}`, 198, 26, {align: 'right'});
  if (environment === 'backoffice')
    doc.text(isPresent(submissionLists.average_processing_time) ? (I18n.t('js.PDFGenerator.submissionLists.averageProcessingTime') + space + parseSubmissionListProcessingTime({ processing_time: submissionLists.average_processing_time })) : '', 10, 36);
  doc.setFontSize(12);

  let y = 45
  Object.entries(filters).forEach(([fieldName, fieldValue]) => {
    if (fieldName.indexOf('feedback') === -1 && fieldName.indexOf('sort') === -1 && fieldName.indexOf('date') === -1 && fieldValue && !(fieldName === 'states' && fieldValue.length === 0)) {
      y += 10
      doc.text((['middleman_id', 'middleman_business_name'].includes(fieldName) ? companyPoint : parseFilterName(fieldName, fieldValue)) + ':' + space +
        (fieldName === 'created_by' ? filterCreatedBy(fieldValue, companyPoint) :
          (fieldName === 'state' ? parseSubmissionListState(fieldValue) :
            (fieldName === 'middleman_business_name' ? filterMiddlemanBusinessname(fieldValue, companyPoint) :
              (fieldName === 'user_id' ? filterUsername(users, fieldValue) :
                (fieldName === 'grader_company_id' ? filterGraderCompany(graderCompanies, fieldValue) :
                  (fieldName === 'amount_to_check' ? titleize(fieldValue).replaceAll('_', ' ') :
                    (['invoiced', 'shadow', 'home_pick_up_requested', 'home_pick_up_courier_sent'].includes(fieldName) ? parseBoolean(fieldValue) :
                      (fieldName === 'states' ? fieldValue.map((s) => titleize(s)).toString().replaceAll(',', ', ') :
                        (fieldName === 'creation_environment' ? titleize(fieldValue.replaceAll('_', ' ').replaceAll('-', ' - ')) :
                          (fieldName === 'payment_method' ? titleize(fieldValue.replaceAll('_', ' ')) : fieldValue)))))))))), 10, y);
    }
  })

  y += 10

  if (submissionLists.submission_lists.length > 0) {
    var tableContent = []
    for (const submissionList of submissionLists.submission_lists) {
      tableContent.push(getTableRow(submissionList, environment, isSuperMiddleman, influencersReport))
    }

    const header = environment === 'backoffice' ?
      (
        !influencersReport ?
          [
            I18n.t('js.filters.placeholderOrderId'),
            I18n.t('js.PDFGenerator.submissionLists.user_id'),
            companyPoint,
            I18n.t('js.PDFGenerator.submissionLists.title'),
            I18n.t('js.PDFGenerator.submissionLists.state'),
            titleize(I18n.t('js.PDFGenerator.submissionLists.products')),
            I18n.t('js.PDFGenerator.submissionLists.amount'),
            I18n.t('js.PDFGenerator.submissionLists.invoice'),
            I18n.t('js.PDFGenerator.submissionLists.created_by'),
            I18n.t('js.PDFGenerator.submissionLists.created_at'),
            I18n.t('js.PDFGenerator.submissionLists.confirmed_at'),
            I18n.t('js.PDFGenerator.submissionLists.received_at'),
            I18n.t('js.PDFGenerator.submissionLists.closed_at'),
            I18n.t('js.PDFGenerator.submissionLists.processing_time'),
            I18n.t('js.PDFGenerator.submissionLists.home_pick_up'),
            I18n.t('js.PDFGenerator.submissionLists.tracking_info')
          ]
        :
          [
            I18n.t('js.filters.placeholderOrderId'),
            I18n.t('js.PDFGenerator.submissionLists.confirmed_at'),
            I18n.t('js.PDFGenerator.submissionLists.grading_service_mount'),
            I18n.t('js.PDFGenerator.submissionLists.influencer_commission'),
            I18n.t('js.PDFGenerator.submissionLists.discount_code')
          ]
      )
    :
      (
        isSuperMiddleman ?
          [
            I18n.t('js.filters.placeholderOrderId'),
            I18n.t('js.PDFGenerator.submissionLists.user_id'),
            companyPoint,
            I18n.t('js.PDFGenerator.submissionLists.title'),
            I18n.t('js.PDFGenerator.submissionLists.state'),
            titleize(I18n.t('js.PDFGenerator.submissionLists.products')),
            I18n.t('js.PDFGenerator.submissionLists.amount'),
            I18n.t('js.PDFGenerator.submissionLists.created_at'),
            I18n.t('js.PDFGenerator.submissionLists.confirmed_at'),
            I18n.t('js.PDFGenerator.submissionLists.received_at'),
            I18n.t('js.PDFGenerator.submissionLists.closed_at'),
            I18n.t('js.PDFGenerator.submissionLists.tracking_info')
          ]
        :
          [
            I18n.t('js.filters.placeholderOrderId'),
            I18n.t('js.PDFGenerator.submissionLists.user_id'),
            I18n.t('js.PDFGenerator.submissionLists.title'),
            I18n.t('js.PDFGenerator.submissionLists.state'),
            titleize(I18n.t('js.PDFGenerator.submissionLists.products')),
            I18n.t('js.PDFGenerator.submissionLists.amount'),
            I18n.t('js.PDFGenerator.submissionLists.created_at'),
            I18n.t('js.PDFGenerator.submissionLists.confirmed_at'),
            I18n.t('js.PDFGenerator.submissionLists.received_at'),
            I18n.t('js.PDFGenerator.submissionLists.closed_at'),
            I18n.t('js.PDFGenerator.submissionLists.tracking_info')
          ]
      )

    doc.autoTable({
      theme: 'plain',
      head: [header],
      body: tableContent,
      margin: {left: 2, right: 2},
      startY: doc.pageCount > 1 ? doc.lastAutoTable.finalY + 10 : y,
      headStyles: {
        font: 'Koruri-Bold',
        fontSize: 8,
        lineWidth: 0.5,
        lineColor: [0, 0, 0],
        align: 'center'
      },
      bodyStyles: {
        font: 'Koruri-Regular',
        fontSize: 7,
        lineWidth: 0.3,
        lineColor: [0, 0, 0],
        align: 'center'
      },
      alternateRowStyles: {
        fillColor: [230, 230, 230]
      }
    })
  }

  addFooters(doc)
  var pdfName= 'AiGrading_Orders.pdf'
  doc.save(pdfName);
}
